module.exports = __webpack_public_path__ + "img/humidity.f0e5d6ef.svg";